module.exports = ["36","OC","PU","SK","MF","OI","OM","DD","DB","ST","BL","IV","FM","C1","AL","SA","SB","FR","WP","HA","NX","HU","VV","RE","CB","MZ","UM","FK","FX","WI","MN","M1","AH","SU","EU","EZ","UT","DT","S0"]


//////////////////
// WEBPACK FOOTER
// ./~/device-detector-js/dist/parsers/client/fixtures/mobile-only-browsers.json
// module id = 1397
// module chunks = 14 15